export const LOGIN_ATTEMPT = "LOGIN_ATTEMPT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_INFO_RESET = "LOGIN_INFO_RESET";
export const LOGOUT = "LOGOUT";

export const FETCH_USER_INFO_SUCCESS = "FETCH_USER_INFO_SUCCESS";
export const FETCH_USER_INFO_ERROR = "FETCH_USER_INFO_ERROR";

export const SIGN_UP_ATTEMPT = "SIGN_UP_ATTEMPT";
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const SIGN_UP_ERROR = "SIGN_UP_ERROR";
export const SIGN_UP_INFO_RESET = "SIGN_UP_INFO_RESET";

export const POST_COMPANY_INFROMATION_ATTEMPT =
  "POST_COMPANY_INFROMATION_ATTEMPT";
export const POST_COMPANY_INFROMATION_SUCCESS =
  "POST_COMPANY_INFROMATION_SUCCESS";
export const POST_COMPANY_INFROMATION_ERROR = "POST_COMPANY_INFROMATION_ERROR";
export const POST_COMPANY_INFROMATION_RESET = "POST_COMPANY_INFROMATION_RESET";

export const VERIFY_EMAIL_ATTEMPT = "VERIFY_EMAIL_ATTEMPT";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_ERROR = "VERIFY_EMAIL_ERROR";
export const VERIFY_EMAIL_INFO_RESET = "VERIFY_EMAIL_INFO_RESET";

export const RESEND_CODE_ATTEMPT = "RESEND_CODE_ATTEMPT";
export const RESEND_CODE_SUCCESS = "RESEND_CODE_SUCCESS";
export const RESEND_CODE_ERROR = "RESEND_CODE_ERROR";
export const RESEND_CODE_INFO_RESET = "RESEND_CODE_INFO_RESET";

export const RESET_PASSWORD_REQUEST_ATTEMPT = "RESET_PASSWORD_REQUEST_ATTEMPT";
export const RESET_PASSWORD_REQUEST_SUCCESS = "RESET_PASSWORD_REQUEST_SUCCESS";
export const RESET_PASSWORD_REQUEST_ERROR = "RESET_PASSWORD_REQUEST_ERROR";
export const RESET_PASSWORD_RESET_INFO = "RESET_PASSWORD_RESET_INFO";

export const VERIFY_PASSWORD_RESET_CODE_ATTEMPT =
  "VERIFY_PASSWORD_RESET_CODE_ATTEMPT";
export const VERIFY_PASSWORD_RESET_CODE_SUCCESS =
  "VERIFY_PASSWORD_RESET_CODE_SUCCESS";
export const VERIFY_PASSWORD_RESET_CODE_ERROR =
  "VERIFY_PASSWORD_RESET_CODE_ERROR";
export const VERIFY_PASSWORD_CODE_RESET_INFO =
  "VERIFY_PASSWORD_CODE_RESET_INFO";

export const UPDATE_PASSWORD_ATTEMPT = "UPDATE_PASSWORD_ATTEMPT";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_ERROR = "UPDATE_PASSWORD_ERROR";
export const UPDATE_PASSWORD_RESET_INFO = "UPDATE_PASSWORD_RESET_INFO";

export const FETCH_TAXPAYERS_ATTEMPT = "FETCH_TAXPAYERS_ATTEMPT";
export const FETCH_TAXPAYERS_SUCCESS = "FETCH_TAXPAYERS_SUCCESS";
export const FETCH_TAXPAYERS_ERROR = "FETCH_TAXPAYERS_ERROR";
export const FETCH_TAXPAYERS_RESET_INFO = "FETCH_TAXPAYERS_RESET_INFO";

export const FETCH_FISCAL_DEVICES_ATTEMPT = "FETCH_FISCAL_DEVICES_ATTEMPT";
export const FETCH_FISCAL_DEVICES_SUCCESS = "FETCH_FISCAL_DEVICES_SUCCESS";
export const FETCH_FISCAL_DEVICES_ERROR = "FETCH_FISCAL_DEVICES_ERROR";
export const FETCH_FISCAL_DEVICES_RESET_INFO =
  "FETCH_FISCAL_DEVICES_RESET_INFO";

export const SELECT_FISCAL_DEVICE = "SELECT_FISCAL_DEVICE";
export const SELECT_ALL_FISCAL_DEVICES = "SELECT_ALL_FISCAL_DEVICES";

export const FETCH_PENDING_VENDING_CONTROLLERS_ATTEMPT =
  "FETCH_PENDING_VENDING_CONTROLLERS_ATTEMPT";
export const FETCH_PENDING_VENDING_CONTROLLERS_SUCCESS =
  "FETCH_PENDING_VENDING_CONTROLLERS";
export const FETCH_PENDING_VENDING_CONTROLLERS_ERROR =
  "FETCH_PENDING_VENDING_CONTROLLERS_ERROR";

export const FETCH_ACTIVE_VENDING_CONTROLLERS_ATTEMPT =
  "FETCH_ACTIVE_VENDING_CONTROLLERS_ATTEMPT";
export const FETCH_ACTIVE_VENDING_CONTROLLERS_SUCCESS =
  "FETCH_ACTIVE_VENDING_CONTROLLERS_SUCCESS";
export const FETCH_ACTIVE_VENDING_CONTROLLERS_ERROR =
  "FETCH_ACTIVE_VENDING_CONTROLLERS_ERROR";

export const ADD_VENDING_CONTROLLER_TO_FISCAL_DEVICE_ATTEMPT =
  "ADD_VENDING_CONTROLLER_TO_FISCAL_DEVICE_ATTEMPT";
export const ADD_VENDING_CONTROLLER_TO_FISCAL_DEVICE_SUCCESS =
  "ADD_VENDING_CONTROLLER_TO_FISCAL_DEVICE_SUCCESS";
export const ADD_VENDING_CONTROLLER_TO_FISCAL_DEVICE_ERROR =
  "ADD_VENDING_CONTROLLER_TO_FISCAL_DEVICE_ERROR";
export const ADD_VENDING_CONTROLLER_TO_FISCAL_DEVICE_RESET =
  "ADD_VENDING_CONTROLLER_TO_FISCAL_DEVICE_RESET";

export const ADD_ITEM_TO_VENDING_CONTROLLER_ATTEMPT =
  "ADD_ITEM_TO_VENDING_CONTROLLER_ATTEMPT";
export const ADD_ITEM_TO_VENDING_CONTROLLER_SUCCESS =
  "ADD_ITEM_TO_VENDING_CONTROLLER_SUCCESS";
export const ADD_ITEM_TO_VENDING_CONTROLLER_ERROR =
  "ADD_ITEM_TO_VENDING_CONTROLLER_ERROR";
export const ADD_ITEM_TO_VENDING_CONTROLLER_RESET =
  "ADD_ITEM_TO_VENDING_CONTROLLER_RESET";

export const GET_VENDING_CONTROLLER_ATTEMPT = "GET_VENDING_CONTROLLER_ATTEMPT";
export const GET_VENDING_CONTROLLER_SUCCESS = "GET_VENDING_CONTROLLER_SUCCESS";
export const GET_VENDING_CONTROLLER_ERROR = "GET_VENDING_CONTROLLER_ERROR";
export const GET_VENDING_CONTROLLER_RESET_STATE =
  "GET_VENDING_CONTROLLER_RESET_STATE";

export const GET_VENDING_CONTROLLER_INVOICES_ATTEMPT =
  "GET_VENDING_CONTROLLER_INVOICES_ATTEMPT";
export const GET_VENDING_CONTROLLER_INVOICES_SUCCESS =
  "GET_VENDING_CONTROLLER_INVOICES_SUCCESS";
export const GET_VENDING_CONTROLLER_INVOICES_ERROR =
  "GET_VENDING_CONTROLLER_INVOICES_ERROR";

export const GET_FISCAL_DEVICE_INVOICES_ATTEMPT =
  "GET_FISCAL_DEVICE_INVOICES_ATTEMPT";
export const GET_FISCAL_DEVICE_INVOICES_SUCCESS =
  "GET_FISCAL_DEVICE_INVOICES_SUCCESS";
export const GET_FISCAL_DEVICE_INVOICES_ERROR =
  "GET_FISCAL_DEVICE_INVOICES_ERROR";

export const GET_ALL_TAX_LABELS = "GET_ALL_TAX_LABELS";
export const ADD_TAX_LABEL_ATTEMPT = "ADD_TAX_LABEL_ATTEMPT";
export const ADD_TAX_LABEL_SUCCESS = "ADD_TAX_LABEL_SUCCESS";
export const ADD_TAX_LABEL_ERROR = "ADD_TAX_LABEL_ERROR";
export const ADD_TAX_LABEL_RESET_STATE = "ADD_TAX_LABEL_RESET_STATE";

export const DELETE_TAX_LABEL_ATTEMPT = "DELETE_TAX_LABEL_ATTEMPT";
export const DELETE_TAX_LABEL_SUCCESS = "DELETE_TAX_LABEL_SUCCESS";
export const DELETE_TAX_LABEL_ERROR = "DELETE_TAX_LABEL_ERROR";
export const DELETE_TAX_LABEL_RESET_STATE = "DELETE_TAX_LABEL_RESET_STATE";

export const DELETE_ITEM_ATTEMPT = "DELETE_ITEM_ATTEMPT";
export const DELETE_ITEM_SUCCESS = "DELETE_ITEM_SUCCESS";
export const DELETE_ITEM_ERROR = "DELETE_ITEM_ERROR";
export const DELETE_ITEM_RESET_STATE = "DELETE_ITEM_RESET_STATE";

export const UPDATE_ITEM_ATTEMPT = "UPDATE_ITEM_ATTEMPT";
export const UPDATE_ITEM_SUCCESS = "UPDATE_ITEM_SUCCESS";
export const UPDATE_ITEM_ERROR = "UPDATE_ITEM_ERROR";
export const UPDATE_ITEM_RESET_STATE = "UPDATE_ITEM_RESET_STATE";

export const UPDATE_VC_ATTEMPT = "UPDATE_VC_ATTEMPT";
export const UPDATE_VC_SUCCESS = "UPDATE_VC_SUCCESS";
export const UPDATE_VC_ERROR = "UPDATE_VC_ERROR";
export const UPDATE_VC_RESET_STATE = "UPDATE_VC_RESET_STATE";

export const FETCH_SINGLE_FISCAL_DEVICE_ATTEMPT =
  "FETCH_SINGLE_FISCAL_DEVICE_ATTEMPT";
export const FETCH_SINGLE_FISCAL_DEVICE_SUCCESS =
  "FETCH_SINGLE_FISCAL_DEVICE_SUCCESS";
export const FETCH_SINGLE_FISCAL_DEVICE_ERROR =
  "FETCH_SINGLE_FISCAL_DEVICE_ERROR";
export const FETCH_SINGLE_FISCAL_DEVICE_RESET_STATE =
  "FETCH_SINGLE_FISCAL_DEVICE_RESET_STATE";

export const DELETE_SINGLE_FISCAL_DEVICE_ATTEMPT =
  "DELETE_SINGLE_FISCAL_DEVICE_ATTEMPT";
export const DELETE_SINGLE_FISCAL_DEVICE_SUCCESS =
  "DELETE_SINGLE_FISCAL_DEVICE_SUCCESS";
export const DELETE_SINGLE_FISCAL_DEVICE_ERROR =
  "DELETE_SINGLE_FISCAL_DEVICE_ERROR";
export const DELETE_SINGLE_FISCAL_DEVICE_RESET_STATE =
  "DELETE_SINGLE_FISCAL_DEVICE_RESET_STATE";

export const UPDATE_FISCAL_DEVICE_ATTEMPT = "UPDATE_FISCAL_DEVICE_ATTEMPT";
export const UPDATE_FISCAL_DEVICE_SUCCESS = "UPDATE_FISCAL_DEVICE_SUCCESS";
export const UPDATE_FISCAL_DEVICE_ERROR = "UPDATE_FISCAL_DEVICE_ERROR";
export const UPDATE_FISCAL_DEVICE_RESET_STATE =
  "UPDATEE_FISCAL_DEVICE_RESET_STATE";

export const FETCH_ALL_USERS_ATTEMPT = "FETCH_ALL_USERS_ATTEMPT";
export const FETCH_ALL_USERS_SUCCESS = "FETCH_ALL_USERS_SUCCESS";
export const FETCH_ALL_USERS_ERROR = "FETCH_ALL_USERS_ERROR";

export const FETCH_SINGLE_USER_ATTEMPT = "FETCH_SINGLE_USER_ATTEMPT";
export const FETCH_SINGLE_USER_SUCCESS = "FETCH_SINGLE_USER_SUCCESS";
export const FETCH_SINGLE_USER_ERROR = "FETCH_SINGLE_USER_ERROR";
export const FETCH_SINGLE_USER_RESET_STATE = "FETCH_SINGLE_USER_RESET_STATE";

export const UPDATE_SINGLE_USER_ATTEMPT = "UPDATE_SINGLE_USER_ATTEMPT";
export const UPDATE_SINGLE_USER_SUCCESS = "UPDATE_SINGLE_USER_SUCCESS";
export const UPDATE_SINGLE_USER_ERROR = "UPDATE_SINGLE_USER_ERROR";
export const UPDATE_SINGLE_USER_RESET_STATE = "UPDATE_SINGLE_USER_RESET_STATE";

export const DELETE_USER_ATTEMPT = "DELETE_USER_ATTEMPT";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";
export const DELETE_USER_RESET_STATE = "DELETE_USER_RESET_STATE";

export const TOGGLE_USER_ADVERTISEMENT_ATTEMPT = "TOGGLE_USER_ADVERTISEMENT_ATTEMPT";
export const TOGGLE_USER_ADVERTISEMENT_SUCCESS = "TOGGLE_USER_ADVERTISEMENT_SUCCESS";
export const TOGGLE_USER_ADVERTISEMENT_ERROR = "TOGGLE_USER_ADVERTISEMENT_ERROR";
export const TOGGLE_USER_ADVERTISEMENT_RESET_STATE = "TOGGLE_USER_ADVERTISEMENT_RESET_STATE";

export const FETCH_BUSINESS_UNIT_CURRENT_REPORT_ATTEMPT =
  "FETCH_BUSINESS_UNIT_CURRENT_REPORT_ATTEMPT";
export const FETCH_BUSINESS_UNIT_CURRENT_REPORT_SUCCESS =
  "FETCH_BUSINESS_UNIT_CURRENT_REPORT_SUCCESS";
export const FETCH_BUSINESS_UNIT_CURRENT_REPORT_ERROR =
  "FETCH_BUSINESS_UNIT_CURRENT_REPORT_ERROR";
export const FETCH_BUSINESS_UNIT_CURRENT_REPORT_RESET_STATE =
  "FETCH_BUSINESS_UNIT_CURRENT_REPORT";

export const FETCH_BUSINESS_UNIT_YEAR_REPORT_ATTEMPT =
  "FETCH_BUSINESS_UNIT_YEAR_REPORT_ATTEMPT";
export const FETCH_BUSINESS_UNIT_YEAR_REPORTT_SUCCESS =
  "FETCH_BUSINESS_UNIT_YEAR_REPORTT_SUCCESS";
export const FETCH_BUSINESS_UNIT_YEAR_REPORT_ERROR =
  "FETCH_BUSINESS_UNIT_YEAR_REPORT_ERROR";
export const FETCH_BUSINESS_UNIT_YEAR_REPORT_STATE =
  "FETCH_BUSINESS_UNIT_YEAR_REPORT_STATE";

export const FETCH_ALL_BUSINESS_UNITS_YEAR_REPORT_ATTEMPT =
  "FETCH_ALL_BUSINESS_UNITS_YEAR_REPORT_ATTEMPT";
export const FETCH_ALL_BUSINESS_UNITS_YEAR_REPORT_SUCCESS =
  "FETCH_ALL_BUSINESS_UNITS_YEAR_REPORT_SUCCESS";
export const FETCH_ALL_BUSINESS_UNITS_YEAR_REPORT_ERROR =
  "FETCH_ALL_BUSINESS_UNITS_YEAR_REPORT_ERROR";
export const FETCH_ALL_BUSINESS_UNITS_YEAR_REPORT_RESET_STATE =
  "FETCH_ALL_BUSINESS_UNITS_YEAR_REPORT_RESET_STATE";

export const FETCH_ALL_BUSINESS_UNITS_CURRENT_DAY_REPORT_ATTEMPT =
  "FETCH_ALL_BUSINESS_UNITS_CURRENT_DAY_REPORT_ATTEMPT";
export const FETCH_ALL_BUSINESS_UNITS_CURRENT_DAY_REPORT_SUCCESS =
  "FETCH_ALL_BUSINESS_UNITS_CURRENT_DAY_REPORT_SUCCESS";
export const FETCH_ALL_BUSINESS_UNITS_CURRENT_DAY_REPORT_ERROR =
  "FETCH_ALL_BUSINESS_UNITS_CURRENT_DAY_REPORT_ERROR";
export const FETCH_ALL_BUSINESS_UNITS_CURRENT_DAY_REPORT_RESET_STATE =
  "FETCH_ALL_BUSINESS_UNITS_CURRENT_DAY_REPORT_RESET_STATE";

export const FETCH_FISCAL_DEVICE_CURRENT_REPORT_ATTEMPT =
  "FETCH_FISCAL_DEVICE_CURRENT_REPORT_ATTEMPT";
export const FETCH_FISCAL_DEVICE_CURRENT_REPORT_SUCCESS =
  "FETCH_FISCAL_DEVICE_CURRENT_REPORT_SUCCESS";
export const FETCH_FISCAL_DEVICE_CURRENT_REPORT_ERROR =
  "FETCH_FISCAL_DEVICE_CURRENT_REPORT_ERROR";
export const FETCH_FISCAL_DEVICE_CURRENT_REPORT_RESET_STATE =
  "FETCH_FISCAL_DEVICE_CURRENT_REPORT_RESET_STATE";

export const FETCH_ALL_BUSINESS_UNITS_LAST_7_DAYS_REPORT_ATTEMPT =
  "FETCH_ALL_BUSINESS_UNITS_LAST_7_DAYS_REPORT_ATTEMPT";
export const FETCH_ALL_BUSINESS_UNITS_LAST_7_DAYS_REPORT_SUCCESS =
  "FETCH_ALL_BUSINESS_UNITS_LAST_7_DAYS_REPORT_SUCCESS";
export const FETCH_ALL_BUSINESS_UNITS_LAST_7_DAYS_REPORT_ERROR =
  "FETCH_ALL_BUSINESS_UNITS_LAST_7_DAYS_REPORT_ERROR";
export const FETCH_ALL_BUSINESS_UNITS_LAST_7_DAYS_REPORT_RESET_STATE =
  "FETCH_ALL_BUSINESS_UNITS_LAST_7_DAYS_REPORT_RESET_STATE";

export const FETCH_ALL_BUSINESS_UNITS_LAST_30_DAYS_REPORT_ATTEMPT =
  "FETCH_ALL_BUSINESS_UNITS_LAST_30_DAYS_REPORT_ATTEMPT";
export const FETCH_ALL_BUSINESS_UNITS_LAST_30_DAYS_REPORT_SUCCESS =
  "FETCH_ALL_BUSINESS_UNITS_LAST_30_DAYS_REPORT_SUCCESS";
export const FETCH_ALL_BUSINESS_UNITS_LAST_30_DAYS_REPORT_ERROR =
  "FETCH_ALL_BUSINESS_UNITS_LAST_30_DAYS_REPORT_ERROR";
export const FETCH_ALL_BUSINESS_UNITS_LAST_30_DAYS_REPORT_RESET_STATE =
  "FETCH_ALL_BUSINESS_UNITS_LAST_30_DAYS_REPORT_RESET_STATE";

export const FETCH_ALL_BUSINESS_UNITS_CURRENT_MONTH_DAYS_REPORT_ATTEMPT =
  "FETCH_ALL_BUSINESS_UNITS_CURRENT_MONTH_DAYS_REPORT_ATTEMPT";
export const FETCH_ALL_BUSINESS_UNITS_CURRENT_MONTH_DAYS_REPORT_SUCCESS =
  "FETCH_ALL_BUSINESS_UNITS_CURRENT_MONTH_DAYS_REPORT_SUCCESS";
export const FETCH_ALL_BUSINESS_UNITS_CURRENT_MONTH_DAYS_REPORT_ERROR =
  "FETCH_ALL_BUSINESS_UNITS_CURRENT_MONTH_DAYS_REPORT_ERROR";
export const FETCH_ALL_BUSINESS_UNITS_CURRENT_MONTH_DAYS_REPORT_RESET_STATE =
  "FETCH_ALL_BUSINESS_UNITS_CURRENT_MONTH_DAYS_REPORT_RESET_STATE";

export const FETCH_ALL_BUSINESS_UNITS_24H_REPORT_ATTEMPT =
  "FETCH_ALL_BUSINESS_UNITS_24H_REPORT_ATTEMPT";
export const FETCH_ALL_BUSINESS_UNITS_24H_REPORT_SUCCESS =
  "FETCH_ALL_BUSINESS_UNITS_24H_REPORT_SUCCESS";
export const FETCH_ALL_BUSINESS_UNITS_24H_REPORT_ERROR =
  "FETCH_ALL_BUSINESS_UNITS_24H_REPORT_ERROR";

export const FETCH_ALL_BUSINESS_UNITS_LAST_6_MONTHS_REPORT_ATTEMPT =
  "FETCH_ALL_BUSINESS_UNITS_LAST_6_MONTHS_REPORT_ATTEMPT";
export const FETCH_ALL_BUSINESS_UNITS_LAST_6_MONTHS_REPORT_SUCCESS =
  "FETCH_ALL_BUSINESS_UNITS_LAST_6_MONTHS_REPORT_SUCCESS";
export const FETCH_ALL_BUSINESS_UNITS_LAST_6_MONTHS_REPORT_ERROR =
  "FETCH_ALL_BUSINESS_UNITS_LAST_6_MONTHS_REPORT_ERROR";
export const FETCH_ALL_BUSINESS_UNITS_LAST_6_MONTHS_REPORT_RESET_STATE =
  "FETCH_ALL_BUSINESS_UNITS_LAST_6_MONTHS_REPORT_RESET_STATE";

export const FETCH_FISCAL_DEVICE_LOGS_ATTEMPT =
  "FETCH_FISCAL_DEVICE_LOGS_ATTEMPT";
export const FETCH_FISCAL_DEVICE_LOGS_SUCCESS =
  "FETCH_FISCAL_DEVICE_LOGS_SUCCESS";
export const FETCH_FISCAL_DEVICE_LOGS_RESET_STATE =
  "FETCH_FISCAL_DEVICE_LOGS_RESET_STATE";

export const FETCH_CERTIFICATES_ATTEMPT = "FETCH_CERTIFICATES_ATTEMPT";
export const FETCH_CERTIFICATES_SUCCESS = "FETCH_CERTIFICATES_SUCCESS";
export const FETCH_CERTIFICATES_ERROR = "FETCH_CERTIFICATES_ERROR";
export const FETCH_CERTIFICATES_RESET_STATE = "FETCH_CERTIFICATES_RESET_STATE";

export const DELETE_CERTIFICATE_ATTEMPT = "DELETE_CERTIFICATE_ATTEMPT";
export const DELETE_CERTIFICATE_SUCCESS = "DELETE_CERTIFICATE_SUCCESS";
export const DELETE_CERTIFICATE_ERROR = "DELETE_CERTIFICATE_ERROR";
export const DELETE_CERTIFICATE_RESET_STATE = "DELETE_CERTIFICATE_RESET_STATE";

// API Keys
export const FETCH_API_KEYS_ATTEMPT = "FETCH_API_KEYS_ATTEMPT";
export const FETCH_API_KEYS_SUCCESS = "FETCH_API_KEYS_SUCCESS";
export const FETCH_API_KEYS_ERROR = "FETCH_API_KEYS_ERROR";
export const FETCH_API_KEYS_RESET_STATE = "FETCH_API_KEYS_RESET_STATE";
export const CREATE_API_KEY_ATTEMPT = "CREATE_API_KEY_ATTEMPT";
export const CREATE_API_KEY_SUCCESS = "CREATE_API_KEY_SUCCESS";
export const CREATE_API_KEY_ERROR = "CREATE_API_KEY_ERROR";
export const CREATE_API_KEY_RESET_STATE = "CREATE_API_KEY_RESET_STATE";
export const UPDATE_API_KEY_ATTEMPT = "UPDATE_API_KEY_ATTEMPT";
export const UPDATE_API_KEY_SUCCESS = "UPDATE_API_KEY_SUCCESS";
export const UPDATE_API_KEY_ERROR = "UPDATE_API_KEY_ERROR";
export const UPDATE_API_KEY_RESET_STATE = "UPDATE_API_KEY_RESET_STATE";
export const DELETE_API_KEY_ATTEMPT = "DELETE_API_KEY_ATTEMPT";
export const DELETE_API_KEY_SUCCESS = "DELETE_API_KEY_SUCCESS";
export const DELETE_API_KEY_ERROR = "DELETE_API_KEY_ERROR";
export const DELETE_API_KEY_RESET_STATE = "DELETE_API_KEY_RESET_STATE";

export const FETCH_QUEUE_METRICS_ATTEMPT = "FETCH_QUEUE_METRICS_ATTEMPT";
export const FETCH_QUEUE_METRICS_SUCCESS = "FETCH_QUEUE_METRICS_SUCCESS";
export const FETCH_QUEUE_METRICS_ERROR = "FETCH_QUEUE_METRICS_ERROR";

export const FETCH_QUEUE_SUMMARY_ATTEMPT = "FETCH_QUEUE_SUMMARY_ATTEMPT";
export const FETCH_QUEUE_SUMMARY_SUCCESS = "FETCH_QUEUE_SUMMARY_SUCCESS";
export const FETCH_QUEUE_SUMMARY_ERROR = "FETCH_QUEUE_SUMMARY_ERROR";

export const FETCH_QUEUE_JOBS_ATTEMPT = "FETCH_QUEUE_JOBS_ATTEMPT";
export const FETCH_QUEUE_JOBS_SUCCESS = "FETCH_QUEUE_JOBS_SUCCESS";
export const FETCH_QUEUE_JOBS_ERROR = "FETCH_QUEUE_JOBS_ERROR";

export const TRUNCATE_QUEUE_ATTEMPT = "TRUNCATE_QUEUE_ATTEMPT";
export const TRUNCATE_QUEUE_SUCCESS = "TRUNCATE_QUEUE_SUCCESS";
export const TRUNCATE_QUEUE_ERROR = "TRUNCATE_QUEUE_ERROR";
export const TRUNCATE_QUEUE_RESET_STATE = "TRUNCATE_QUEUE_RESET_STATE";

export const FETCH_VSDC_FAILED_REQUESTS_ATTEMPT = "FETCH_VSDC_FAILED_REQUESTS_ATTEMPT";
export const FETCH_VSDC_FAILED_REQUESTS_SUCCESS = "FETCH_VSDC_FAILED_REQUESTS_SUCCESS";
export const FETCH_VSDC_FAILED_REQUESTS_ERROR = "FETCH_VSDC_FAILED_REQUESTS_ERROR";

export const CLEAR_VSDC_FAILED_REQUESTS_ATTEMPT = "CLEAR_VSDC_FAILED_REQUESTS_ATTEMPT";
export const CLEAR_VSDC_FAILED_REQUESTS_SUCCESS = "CLEAR_VSDC_FAILED_REQUESTS_SUCCESS";
export const CLEAR_VSDC_FAILED_REQUESTS_ERROR = "CLEAR_VSDC_FAILED_REQUESTS_ERROR";
export const CLEAR_VSDC_FAILED_REQUESTS_RESET_STATE = "CLEAR_VSDC_FAILED_REQUESTS_RESET_STATE";

export const FETCH_TEST_DEVICES_ATTEMPT = "FETCH_TEST_DEVICES_ATTEMPT";
export const FETCH_TEST_DEVICES_SUCCESS = "FETCH_TEST_DEVICES_SUCCESS";
export const FETCH_TEST_DEVICES_ERROR = "FETCH_TEST_DEVICES_ERROR";

export const SUBMIT_TEST_INVOICE_ATTEMPT = "SUBMIT_TEST_INVOICE_ATTEMPT";
export const SUBMIT_TEST_INVOICE_SUCCESS = "SUBMIT_TEST_INVOICE_SUCCESS";
export const SUBMIT_TEST_INVOICE_ERROR = "SUBMIT_TEST_INVOICE_ERROR";
export const SUBMIT_TEST_INVOICE_RESET_STATE = "SUBMIT_TEST_INVOICE_RESET_STATE";

// Billing Invoices
export const FETCH_BILLING_INVOICES_ATTEMPT = "FETCH_BILLING_INVOICES_ATTEMPT";
export const FETCH_BILLING_INVOICES_SUCCESS = "FETCH_BILLING_INVOICES_SUCCESS";
export const FETCH_BILLING_INVOICES_ERROR = "FETCH_BILLING_INVOICES_ERROR";

export const FETCH_BILLING_INVOICE_ATTEMPT = "FETCH_BILLING_INVOICE_ATTEMPT";
export const FETCH_BILLING_INVOICE_SUCCESS = "FETCH_BILLING_INVOICE_SUCCESS";
export const FETCH_BILLING_INVOICE_ERROR = "FETCH_BILLING_INVOICE_ERROR";
export const FETCH_BILLING_INVOICE_RESET_STATE = "FETCH_BILLING_INVOICE_RESET_STATE";

export const CREATE_BILLING_INVOICE_ATTEMPT = "CREATE_BILLING_INVOICE_ATTEMPT";
export const CREATE_BILLING_INVOICE_SUCCESS = "CREATE_BILLING_INVOICE_SUCCESS";
export const CREATE_BILLING_INVOICE_ERROR = "CREATE_BILLING_INVOICE_ERROR";
export const CREATE_BILLING_INVOICE_RESET_STATE = "CREATE_BILLING_INVOICE_RESET_STATE";

export const UPDATE_BILLING_INVOICE_ATTEMPT = "UPDATE_BILLING_INVOICE_ATTEMPT";
export const UPDATE_BILLING_INVOICE_SUCCESS = "UPDATE_BILLING_INVOICE_SUCCESS";
export const UPDATE_BILLING_INVOICE_ERROR = "UPDATE_BILLING_INVOICE_ERROR";
export const UPDATE_BILLING_INVOICE_RESET_STATE = "UPDATE_BILLING_INVOICE_RESET_STATE";

export const UPDATE_BILLING_INVOICE_REFERENCE_ATTEMPT = "UPDATE_BILLING_INVOICE_REFERENCE_ATTEMPT";
export const UPDATE_BILLING_INVOICE_REFERENCE_SUCCESS = "UPDATE_BILLING_INVOICE_REFERENCE_SUCCESS";
export const UPDATE_BILLING_INVOICE_REFERENCE_ERROR = "UPDATE_BILLING_INVOICE_REFERENCE_ERROR";
export const UPDATE_BILLING_INVOICE_REFERENCE_RESET_STATE = "UPDATE_BILLING_INVOICE_REFERENCE_RESET_STATE";

export const SEND_BILLING_INVOICE_ATTEMPT = "SEND_BILLING_INVOICE_ATTEMPT";
export const SEND_BILLING_INVOICE_SUCCESS = "SEND_BILLING_INVOICE_SUCCESS";
export const SEND_BILLING_INVOICE_ERROR = "SEND_BILLING_INVOICE_ERROR";
export const SEND_BILLING_INVOICE_RESET_STATE = "SEND_BILLING_INVOICE_RESET_STATE";

export const CANCEL_BILLING_INVOICE_ATTEMPT = "CANCEL_BILLING_INVOICE_ATTEMPT";
export const CANCEL_BILLING_INVOICE_SUCCESS = "CANCEL_BILLING_INVOICE_SUCCESS";
export const CANCEL_BILLING_INVOICE_ERROR = "CANCEL_BILLING_INVOICE_ERROR";
export const CANCEL_BILLING_INVOICE_RESET_STATE = "CANCEL_BILLING_INVOICE_RESET_STATE";

export const TOGGLE_BILLING_INVOICE_PAID_ATTEMPT = "TOGGLE_BILLING_INVOICE_PAID_ATTEMPT";
export const TOGGLE_BILLING_INVOICE_PAID_SUCCESS = "TOGGLE_BILLING_INVOICE_PAID_SUCCESS";
export const TOGGLE_BILLING_INVOICE_PAID_ERROR = "TOGGLE_BILLING_INVOICE_PAID_ERROR";
export const TOGGLE_BILLING_INVOICE_PAID_RESET_STATE = "TOGGLE_BILLING_INVOICE_PAID_RESET_STATE";

export const GENERATE_ALL_BILLING_INVOICES_ATTEMPT = "GENERATE_ALL_BILLING_INVOICES_ATTEMPT";
export const GENERATE_ALL_BILLING_INVOICES_SUCCESS = "GENERATE_ALL_BILLING_INVOICES_SUCCESS";
export const GENERATE_ALL_BILLING_INVOICES_ERROR = "GENERATE_ALL_BILLING_INVOICES_ERROR";
export const GENERATE_ALL_BILLING_INVOICES_RESET_STATE = "GENERATE_ALL_BILLING_INVOICES_RESET_STATE";

// Billing Invoice Items
export const FETCH_BILLING_INVOICE_ITEMS_ATTEMPT = "FETCH_BILLING_INVOICE_ITEMS_ATTEMPT";
export const FETCH_BILLING_INVOICE_ITEMS_SUCCESS = "FETCH_BILLING_INVOICE_ITEMS_SUCCESS";
export const FETCH_BILLING_INVOICE_ITEMS_ERROR = "FETCH_BILLING_INVOICE_ITEMS_ERROR";

export const CREATE_BILLING_INVOICE_ITEM_ATTEMPT = "CREATE_BILLING_INVOICE_ITEM_ATTEMPT";
export const CREATE_BILLING_INVOICE_ITEM_SUCCESS = "CREATE_BILLING_INVOICE_ITEM_SUCCESS";
export const CREATE_BILLING_INVOICE_ITEM_ERROR = "CREATE_BILLING_INVOICE_ITEM_ERROR";
export const CREATE_BILLING_INVOICE_ITEM_RESET_STATE = "CREATE_BILLING_INVOICE_ITEM_RESET_STATE";

export const UPDATE_BILLING_INVOICE_ITEM_ATTEMPT = "UPDATE_BILLING_INVOICE_ITEM_ATTEMPT";
export const UPDATE_BILLING_INVOICE_ITEM_SUCCESS = "UPDATE_BILLING_INVOICE_ITEM_SUCCESS";
export const UPDATE_BILLING_INVOICE_ITEM_ERROR = "UPDATE_BILLING_INVOICE_ITEM_ERROR";
export const UPDATE_BILLING_INVOICE_ITEM_RESET_STATE = "UPDATE_BILLING_INVOICE_ITEM_RESET_STATE";

export const DELETE_BILLING_INVOICE_ITEM_ATTEMPT = "DELETE_BILLING_INVOICE_ITEM_ATTEMPT";
export const DELETE_BILLING_INVOICE_ITEM_SUCCESS = "DELETE_BILLING_INVOICE_ITEM_SUCCESS";
export const DELETE_BILLING_INVOICE_ITEM_ERROR = "DELETE_BILLING_INVOICE_ITEM_ERROR";
export const DELETE_BILLING_INVOICE_ITEM_RESET_STATE = "DELETE_BILLING_INVOICE_ITEM_RESET_STATE";

// Billing Invoice Payments
export const FETCH_BILLING_INVOICE_PAYMENTS_ATTEMPT = "FETCH_BILLING_INVOICE_PAYMENTS_ATTEMPT";
export const FETCH_BILLING_INVOICE_PAYMENTS_SUCCESS = "FETCH_BILLING_INVOICE_PAYMENTS_SUCCESS";
export const FETCH_BILLING_INVOICE_PAYMENTS_ERROR = "FETCH_BILLING_INVOICE_PAYMENTS_ERROR";

export const CREATE_BILLING_INVOICE_PAYMENT_ATTEMPT = "CREATE_BILLING_INVOICE_PAYMENT_ATTEMPT";
export const CREATE_BILLING_INVOICE_PAYMENT_SUCCESS = "CREATE_BILLING_INVOICE_PAYMENT_SUCCESS";
export const CREATE_BILLING_INVOICE_PAYMENT_ERROR = "CREATE_BILLING_INVOICE_PAYMENT_ERROR";
export const CREATE_BILLING_INVOICE_PAYMENT_RESET_STATE = "CREATE_BILLING_INVOICE_PAYMENT_RESET_STATE";

export const UPDATE_BILLING_INVOICE_PAYMENT_ATTEMPT = "UPDATE_BILLING_INVOICE_PAYMENT_ATTEMPT";
export const UPDATE_BILLING_INVOICE_PAYMENT_SUCCESS = "UPDATE_BILLING_INVOICE_PAYMENT_SUCCESS";
export const UPDATE_BILLING_INVOICE_PAYMENT_ERROR = "UPDATE_BILLING_INVOICE_PAYMENT_ERROR";
export const UPDATE_BILLING_INVOICE_PAYMENT_RESET_STATE = "UPDATE_BILLING_INVOICE_PAYMENT_RESET_STATE";

export const DELETE_BILLING_INVOICE_PAYMENT_ATTEMPT = "DELETE_BILLING_INVOICE_PAYMENT_ATTEMPT";
export const DELETE_BILLING_INVOICE_PAYMENT_SUCCESS = "DELETE_BILLING_INVOICE_PAYMENT_SUCCESS";
export const DELETE_BILLING_INVOICE_PAYMENT_ERROR = "DELETE_BILLING_INVOICE_PAYMENT_ERROR";
export const DELETE_BILLING_INVOICE_PAYMENT_RESET_STATE = "DELETE_BILLING_INVOICE_PAYMENT_RESET_STATE";

// Bulk Create Billing Invoices
export const BULK_CREATE_BILLING_INVOICES_ATTEMPT = "BULK_CREATE_BILLING_INVOICES_ATTEMPT";
export const BULK_CREATE_BILLING_INVOICES_SUCCESS = "BULK_CREATE_BILLING_INVOICES_SUCCESS";
export const BULK_CREATE_BILLING_INVOICES_ERROR = "BULK_CREATE_BILLING_INVOICES_ERROR";
export const BULK_CREATE_BILLING_INVOICES_RESET_STATE = "BULK_CREATE_BILLING_INVOICES_RESET_STATE";

export const FETCH_INVOICE_SCHEMA_IDS_ATTEMPT = "FETCH_INVOICE_SCHEMA_IDS_ATTEMPT";
export const FETCH_INVOICE_SCHEMA_IDS_SUCCESS = "FETCH_INVOICE_SCHEMA_IDS_SUCCESS";
export const FETCH_INVOICE_SCHEMA_IDS_ERROR = "FETCH_INVOICE_SCHEMA_IDS_ERROR";

export const SELECT_INVOICE_SCHEMA = "SELECT_INVOICE_SCHEMA";
export const SELECT_ALL_INVOICE_SCHEMAS = "SELECT_ALL_INVOICE_SCHEMAS";

// Invoice Prefixes
export const FETCH_INVOICE_PREFIXES_ATTEMPT = "FETCH_INVOICE_PREFIXES_ATTEMPT";
export const FETCH_INVOICE_PREFIXES_SUCCESS = "FETCH_INVOICE_PREFIXES_SUCCESS";
export const FETCH_INVOICE_PREFIXES_ERROR = "FETCH_INVOICE_PREFIXES_ERROR";

export const FETCH_INVOICE_PREFIX_ATTEMPT = "FETCH_INVOICE_PREFIX_ATTEMPT";
export const FETCH_INVOICE_PREFIX_SUCCESS = "FETCH_INVOICE_PREFIX_SUCCESS";
export const FETCH_INVOICE_PREFIX_ERROR = "FETCH_INVOICE_PREFIX_ERROR";

export const CREATE_INVOICE_PREFIX_ATTEMPT = "CREATE_INVOICE_PREFIX_ATTEMPT";
export const CREATE_INVOICE_PREFIX_SUCCESS = "CREATE_INVOICE_PREFIX_SUCCESS";
export const CREATE_INVOICE_PREFIX_ERROR = "CREATE_INVOICE_PREFIX_ERROR";
export const CREATE_INVOICE_PREFIX_RESET_STATE = "CREATE_INVOICE_PREFIX_RESET_STATE";

export const UPDATE_INVOICE_PREFIX_ATTEMPT = "UPDATE_INVOICE_PREFIX_ATTEMPT";
export const UPDATE_INVOICE_PREFIX_SUCCESS = "UPDATE_INVOICE_PREFIX_SUCCESS";
export const UPDATE_INVOICE_PREFIX_ERROR = "UPDATE_INVOICE_PREFIX_ERROR";
export const UPDATE_INVOICE_PREFIX_RESET_STATE = "UPDATE_INVOICE_PREFIX_RESET_STATE";

export const DELETE_INVOICE_PREFIX_ATTEMPT = "DELETE_INVOICE_PREFIX_ATTEMPT";
export const DELETE_INVOICE_PREFIX_SUCCESS = "DELETE_INVOICE_PREFIX_SUCCESS";
export const DELETE_INVOICE_PREFIX_ERROR = "DELETE_INVOICE_PREFIX_ERROR";
export const DELETE_INVOICE_PREFIX_RESET_STATE = "DELETE_INVOICE_PREFIX_RESET_STATE";
